"use client";

import { createProjectUrl, getClientCommunities } from "@utils/communityHelper";
import { useEffect, useMemo, useState } from "react";

interface Params {
  item: {
    cta?: { link?: { url?: string } };
    locationID?: string | number;
    slug?: string;
    projectSlug?: string;
  };
  locale: string;
  isPropertyType?: boolean;
}

export function useProjectUrl({ item, locale, isPropertyType }: Params): string {
  const [communities, setCommunities] = useState<any[]>([]);

  useEffect(() => {
    const fetchCommunities = async () => {
      const data = await getClientCommunities();
      setCommunities(data);
    };

    fetchCommunities();
  }, []);

  const finalUrl = createProjectUrl(
    communities,
    item?.cta?.link?.url ?? "",
    item?.locationID?.toString() ?? "",
    item?.slug || item?.projectSlug || "",
    item?.projectSlug,
    locale,
    isPropertyType,
  );

  return finalUrl;
}
